// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sj-0";
export var checkoutRateBadgeLink = "_sj-1";